<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <span>常用时段</span>
      </div>
      <div class="smain">
        <van-empty
          class="side-nav-empty"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="还没有创建常用时段哦～"
          v-if="listAll.length === 0"
          image-size="128"
          style="padding-top: 50px"
        />
        <div class="choice-wrapper">
          <div
            class="periods-item van-hairline--bottom"
            v-for="(item, index) in listAll"
            :key="item.startTime + '~' + item.endTime"
          >
            <van-icon
              class="icon"
              class-prefix="vxs-icon"
              name="system_del"
              size="16"
              color="var(--c3)"
              @click="removePeriods(index)"
            />
            <div class="item-left">
              <div class="periods">
                <span>{{ item.startTime }}～{{ item.endTime }}</span>
                <span class="periods-info">{{
                  app.tool.date.getDiffTimeDesc(item.startTime, item.endTime)
                }}</span>
              </div>
            </div>
            <div @click="editPeriods(index)" class="item-right">修改</div>
          </div>

          <div class="btn-wrapper" @click="addPeriods" v-if="listAll.length < 50">
            <van-icon
              class="icon"
              class-prefix="vxs-icon"
              name="system_add"
              size="16"
              color="var(--c1)"
            />
            <div class="btn-like">新增常用时段</div>
          </div>
        </div>
      </div>
      <side-foot @cancel="close" @confirm="periodsSave" />
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-base.js';

export default {
  name: 'x3-side-sell-prices',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '常用时段设置',
      // 可选的角色对象列表
      listAll: [],
      params: {},
    };
  },
  methods: {
    async render() {
      let opts = this.$route.meta.options || {};
      this.listAll = opts.list;
    },
    valid(start, end) {
      const validResult = this.listAll.every(item => {
        return `${item.startTime}~${item.endTime}` !== `${start}~${end}`;
      });
      if (!validResult) {
        this.$toast('有重复的时段');
      }
      return validResult;
    },
    async addPeriods() {
      app.x3.picker.timeInterval().then(res => {
        if (this.valid(res.value1, res.value2)) {
          this.listAll.push({
            startTime: res.value1,
            endTime: res.value2,
          });
        }
      });
    },
    removePeriods(index) {
      this.listAll.splice(index, 1);
    },
    editPeriods(index) {
      app.x3.picker
        .timeInterval({
          value1: this.listAll[index].startTime,
          value2: this.listAll[index].endTime,
        })
        .then(res => {
          if (this.valid(res.value1, res.value2)) {
            this.listAll[index].startTime = res.value1;
            this.listAll[index].endTime = res.value2;
          }
        });
    },
    async periodsSave() {
      const newList = [...this.listAll].sort((a, b) => {
        const aDate = new Date(`2000/01/01 ${a.startTime}`),
          bDate = new Date(`2000/01/01 ${b.startTime}`);
        return aDate.getTime() - bDate.getTime();
      });
      await this.$api.courseArrangeTimeSave({
        timeList: newList,
      });
      this.confirm();
    },
  },
  created() {
    this.render();
  },
};
</script>
<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .shead {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    color: var(--g6);
    line-height: var(--lh-md);
    display: flex;
  }
  .smain {
    flex: 1;
    overflow: auto;
    .choice-wrapper {
      background: var(--white);
      .periods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: calc(var(--gap) * 16);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        .icon {
        }
        .item-left {
          margin-left: calc(var(--gap) * 8);
          flex: 1;
          .periods {
            color: var(--g8);
            .periods-info {
              color: var(--g6);
              margin-left: calc(var(--gap) * 12);
              font-size: var(--fs-sm);
              line-height: var(--lh-sm);
            }
          }
        }
        .item-right {
          padding: 0 calc(var(--gap) * 8);
          color: var(--c1);
        }
      }
    }
    .btn-wrapper {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: calc(var(--gap) * 16);
      display: flex;
      align-items: center;
      .btn-like {
        color: var(--c1);
        margin-left: calc(var(--gap) * 8);
      }
    }
  }
}
</style>